import { DefaultButton, Label, MessageBar, MessageBarType, PrimaryButton, Spinner, Stack, Text } from '@fluentui/react';
import { useState } from 'react';

import { InvoiceData } from '.';
import { popup } from '../../../addons/Popup';
import { history } from '../../../App/history';
import { postAsync } from '../../../utils/api';
import ContentBox from '../../ContentBox';

export default ({ formId, data }: { formId: string; data: InvoiceData }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <div id="invoice-form" style={{ width: "40vw", marginTop: "12px" }}>
      <Stack tokens={{ childrenGap: 10 }}>
        <Text variant="xxLarge">Fatura Onayla</Text>
        <ContentBox>
          <Stack tokens={{ childrenGap: 10 }}>
            {isSuccess && (
              <MessageBar messageBarType={MessageBarType.success}>
                Fatura işleme alındı.
              </MessageBar>
            )}

            {[
              ["Alıcı Tipi", data.recipientType],
              ["Fatura Tipi", data.invoiceType],
              ["Konnektör", data.endpoint],
            ].map(([label, value]) => (
              <Stack.Item key={label}>
                <Label>{label}</Label>
                {value}
              </Stack.Item>
            ))}
            <Stack horizontal tokens={{ childrenGap: 10 }}>
              <DefaultButton
                text={isClicked && !isLoading ? "Geri" : "İptal"}
                disabled={isLoading}
                onClick={() => history.push("/invoices/new")}
              />
              {isLoading && <Spinner />}
              <PrimaryButton
                text="Onayla"
                disabled={isClicked}
                onClick={async () => {
                  setIsClicked(true);
                  setIsLoading(true);

                  try {
                    const res = await postAsync("/invoices/process", {
                      formId,
                      invoiceType: data.invoiceType,
                      XMLDocumentId: data.XMLDocumentId,
                    });

                    if (!res.success) {
                      throw "Not success";
                    }

                    setIsSuccess(true);
                  } catch (e) {
                    console.error(e);

                    await popup(
                      "Hata: Sistem hatası oluşmuş veya fatura zaten kesilmiş olabilir. Hata detayı: " +
                        (typeof e === "string" || e instanceof Error
                          ? e.toString()
                          : "")
                    );
                  }

                  setIsLoading(false);
                }}
              />
            </Stack>
          </Stack>
        </ContentBox>
      </Stack>
    </div>
  );
};
